import makeClient from '../../urql/client'
import { PROVIDERS } from '../../utils/providers-listing'
import { getProvidersByScope } from '../../utils/providers'

import STORE_CUSTOMER_MUTATION from '@components/landing-form/store-customer-mutation.gql'

const getProviders = (scope) => getProvidersByScope(PROVIDERS, scope)

export const selectProvider = async (providerId, formId) => {
  const [client] = makeClient({ isServer: false, fetch })

  const mutationVariables = {
    customer: {
      provider: providerId,
      formStartedId: formId
    }
  }

  await client.mutation(STORE_CUSTOMER_MUTATION, mutationVariables).toPromise()

  return 'results'
}

export default { getProviders, selectProvider }
